import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SectionCategorie from './sections/SectionCategorie';
import SectionCheckboxes from './sections/SectionCheckboxes';
import SectionLocalita from './sections/SectionLocalita';
import Mappa from '../frontend/mappa/mappa';

const listato = document.getElementById('listato-servizi-container');
const countParagraph = document.getElementById('count-services');
const headerMap = document.querySelector('.mappa-header span');

const useForm = (newFields) => {
	const [fields, setFields] = useState(newFields);
	const updateField = (name, value, target = null) => {
		const newValues = { ...fields };
		newValues[name] = value;
		switch (name) {
			case 'regione':
				newValues.provincia = '0';
				newValues.citta = '0';
				newValues.regione_name =
					target.options[target.selectedIndex].dataset.name;
				newValues.provincia_name = '';
				break;
			case 'provincia':
				newValues.citta = '0';
				newValues.provincia_name =
					target.options[target.selectedIndex].dataset.name;
				break;
			case 'categoria':
				newValues.sottocategoria = '0';
				break;
			default:
				break;
		}
		setFields(newValues);
	};
	const updateObjectFields = (newState) => {
		setFields(newState);
	};
	return [fields, updateField, updateObjectFields];
};

const useIntersect = ({ root = null, rootMargin, threshold = 0 }) => {
	const [entry, updateEntry] = useState({});
	const [node, setNode] = useState(null);

	const observer = useRef(null);

	useEffect(() => {
		if (observer.current) {
			observer.current.disconnect();
		}

		observer.current = new window.IntersectionObserver(
			([newEntry]) => updateEntry(newEntry),
			{
				root,
				rootMargin,
				threshold,
			}
		);

		const { current: currentObserver } = observer;
		if (node) {
			currentObserver.observe(node);
		}
		return () => currentObserver.disconnect();
	}, [node]);

	return [setNode, entry];
};

const SidebarRicerca = () => {
	const [fields, updateField, updateObjectFields] = useForm({
		categoria: '0',
		sottocategoria: '0',
		sostenibile: false,
		regione: '0',
		provincia: '0',
		citta: '0',
		offset: 10,
		stop: 0,
		provincia_name: '',
		regione_name: '',
	});

	const [sidebarToggleClass, setSidebarToggleClass] = useState(
		'is-closed-sidebar sections-container'
	);
	const [toggleButton, setToggleButton] = useState(
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			role="button"
		>
			<defs></defs>
			<path className="ricerca-b" d="M0,0H24V24H0Z" />
			<path
				className="ricerca-a"
				d="M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z"
			/>
		</svg>
	);

	const mappa = new Mappa();

	const loadMoreServices = async () => {
		const newOffset = fields.offset + 10;
		updateField('offset', newOffset);
		const data = {
			...fields,
			newOffset,
		};
		const resultServices = await axios({
			method: 'post',
			url: `${window.location.origin}/wp-json/telepass-v1/services`,
			data: {
				data: JSON.stringify(data),
			},
		});
		if (!resultServices.data) {
			updateField('stop', 1);
		}
		const htmlObject = document.createElement('div');
		htmlObject.innerHTML = resultServices.data;
		listato.appendChild(htmlObject);
	};

	const [setNode, entry] = useIntersect({});
	const [categories, setCategories] = useState([]);
	const [regioni, setRegioni] = useState([]);

	const getCategorieForSelect = async () => {
		const resultCats = await axios(
			`${window.location.origin}/wp-json/telepass-v1/get_macrocategorie`
		);
		return resultCats.data.terms;
	};

	const getRegioniForSelect = async () => {
		const resultRegioni = await axios(
			`${window.location.origin}/wp-json/tsm-v1/regions`
		);
		return resultRegioni.data;
	};

	useEffect(() => {
		const actualFields = { ...fields };
		const fetchData = async () => {
			const categorieForSelect = await getCategorieForSelect();
			setCategories(categorieForSelect);
			const regioniForSelect = await getRegioniForSelect();
			setRegioni(regioniForSelect);
		};
		fetchData();
		const urlParams = new URLSearchParams(window.location.search);
		const catName = urlParams.get('cat');
		if (catName) {
			actualFields.categoria = catName;
		}
		const subcatName = urlParams.get('subcat');
		if (subcatName) {
			actualFields.sottocategoria = subcatName;
		}

		const sostenibile = urlParams.get('sostenibile') ? true : '';
		actualFields.sostenibile = sostenibile;

		const regione = urlParams.get('regione');
		if (regione) {
			actualFields.regione = regione;
		}
		const provincia = urlParams.get('provincia');
		if (provincia) {
			actualFields.provincia = provincia;
		}
		const citta = urlParams.get('citta');
		if (citta) {
			actualFields.citta = citta;
		}
		updateObjectFields(actualFields);
		const fetchDataMap = async () => {
			const resultMappaServizi = await axios({
				method: 'post',
				url: `${window.location.origin}/wp-json/telepass-v1/get_mappa_servizi`,
				data: {
					data: JSON.stringify({
						...actualFields,
						offset: 0,
					}),
				},
			});
			mappa.init(resultMappaServizi.data.servizi);
		};
		fetchDataMap();
		setNode(document.querySelector('#observer'));
	}, []);

	useEffect(() => {
		if (entry.isIntersecting && !fields.stop) {
			const loadData = async () => {
				await loadMoreServices();
			};
			loadData();
		}
	}, [entry.isIntersecting]);

	const updateFieldFromEvent = (event) => {
		updateField(
			event.currentTarget.name,
			event.currentTarget.type === 'checkbox'
				? event.currentTarget.checked
				: event.currentTarget.value,
			event.target
		);
	};

	const getServices = () => {
		const resultServices = axios({
			method: 'post',
			url: `${window.location.origin}/wp-json/telepass-v1/services`,
			data: {
				data: JSON.stringify({
					...fields,
					offset: 0,
					has_clicked_button: 1,
				}),
			},
		});
		return resultServices;
	};

	const getCountServices = () => {
		const resultCountServices = axios({
			method: 'post',
			url: `${window.location.origin}/wp-json/telepass-v1/count_services`,
			data: {
				data: JSON.stringify({
					...fields,
					offset: 0,
				}),
			},
		});
		return resultCountServices;
	};

	const getMappaServizi = async () => {
		const resultMappaServizi = axios({
			method: 'post',
			url: `${window.location.origin}/wp-json/telepass-v1/get_mappa_servizi`,
			data: {
				data: JSON.stringify({
					...fields,
					offset: 0,
				}),
			},
		});
		return resultMappaServizi;
	};

	const searchServices = () => {
		updateObjectFields({
			...fields,
			offset: 10,
			stop: 0,
		});
		const promises = [getServices(), getCountServices(), getMappaServizi()];
		Promise.all(promises).then((results) => {
			listato.innerHTML = results[0].data;
			countParagraph.innerHTML = results[1].data;
			headerMap.innerHTML = results[2].data.header_text;
			mappa.init(results[2].data.servizi);
		});
	};

	const toggleSidebar = () => {
		if (!sidebarToggleClass.includes('is-closed-sidebar')) {
			setSidebarToggleClass('is-closed-sidebar sections-container');
			setToggleButton(
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					role="button"
				>
					<defs></defs>
					<path
						className="ricerca-a"
						d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
					/>
					<path className="ricerca-b" d="M0,0H24V24H0Z" />
				</svg>
			);
			return;
		}
		setSidebarToggleClass('sections-container');
		setToggleButton(
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				role="button"
			>
				<defs></defs>
				<path className="ricerca-b" d="M0,0H24V24H0Z" />
				<path
					className="ricerca-a"
					d="M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z"
				/>
			</svg>
		);
	};

	return (
		<div className="container">
			<div className="columns">
				<div className="column">
					<div className="sidebar_ricerca is-flex">
						<div className="is-flex justify-space-between">
							<p className="sidebar_ricerca-header_text m-t-16 m-b-16">
								Vuoi cercare altro? Modifica i filtri e ripeti
								la ricerca
							</p>
							<span
								onClick={toggleSidebar}
								onKeyDown={toggleSidebar}
								className="toggle-sidebar is-pointer is-hidden-widescreen"
								role="button"
								tabIndex={0}
							>
								{toggleButton}
							</span>
						</div>
						<div className={sidebarToggleClass}>
							<SectionCategorie
								categories={categories}
								categoria={fields.categoria}
								sottocategoria={fields.sottocategoria}
								updateField={updateFieldFromEvent}
							/>
							<SectionCheckboxes
								sostenibile={fields.sostenibile}
								updateField={updateFieldFromEvent}
							/>
							<SectionLocalita
								regioniArray={regioni}
								regione={fields.regione}
								provincia={fields.provincia}
								citta={fields.citta}
								updateField={updateFieldFromEvent}
							/>
							<div className="section-button">
								<button
									type="button"
									className="button is-primary-full is-pulled-right"
									onClick={searchServices}
								>
									Cerca
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SidebarRicerca;
